import { requestStatus } from "../../../../../constants";
import { HOSummaryEmployeeRequestService as serivce } from "../../../../../services/human-organization/summary-register-request.service";

export async function approveRequest(
  request: any,
  currentUser: string,
  leads: any,
  approver: string,
  approver2: string,
  eLocation: string
) {
  if (request) {
    let initFields: any = {
      Title: "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",

      eRequestStatus: requestStatus.submitted,
      eApprovedStatus: requestStatus.submitted,
      eApprovedByITLeadStatus: requestStatus.submitted,

      eApprovedBy: approver.split("|")?.[0]?.toLowerCase(),
      eApprovedByITLead: approver2.split("|")?.[0]?.toLowerCase(),

      eContent: JSON.stringify(request.data),
      eMajor: request.eMajor,
      eLocation,
    };

    const result = await serivce.addSummaryEmployeeRequest({
      fields: initFields,
    });

    return result;
  }
  return false;
}

/*
eContent sẽ như thế này
[
    {
        "@odata.etag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
        "createdDateTime": "2023-11-13T04:01:40Z",
        "eTag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
        "id": "105",
        "lastModifiedDateTime": "2023-11-13T04:23:54Z",
        "webUrl": "https://viagsvn.sharepoint.com/sites/eOfficeDev/Lists/eSummaryEmployeeRequests/105_.000",
        "createdBy": {
            "user": {
                "email": "canbo2@viags.vn",
                "id": "dc50f7c6-8163-42d5-a71d-d7ca62f532e5",
                "displayName": "Can bo 2-VIAGS"
            }
        },
        "lastModifiedBy": {
            "application": {
                "id": "3b7cd5f9-61dc-403b-a425-4d4b43518626",
                "displayName": "viagsoffice.com"
            },
            "user": {
                "email": "canbo1@viags.vn",
                "id": "e49bcd7f-5a27-4c8f-b8af-a70c9406830f",
                "displayName": "Can bo 1-VIAGS"
            }
        },
        "parentReference": {
            "id": "e078a4db-a88c-4c57-8ea4-4b9dfe2df068",
            "siteId": "viagsvn.sharepoint.com,e56d6e5f-9c23-48fb-b7f1-a0336add9496,c7953a0f-e5e6-43fd-8d18-d148e4f6eaf8"
        },
        "contentType": {
            "id": "0x0100B5B91118C9B0944F967418F192282F13",
            "name": "Khoản mục"
        },
        "fields@odata.context": "https://graph.microsoft.com/v1.0/$metadata#sites('e56d6e5f-9c23-48fb-b7f1-a0336add9496')/lists('16e2d37e-d1af-4426-ac9d-2e44b7394bcb')/items('105')/fields/$entity",
        "fields": {
            "@odata.etag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
            "Title": "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",
            "eContent": "[{\"registerPersonel\":\"TuTEST\",\"fullName\":\"nGUYỄN Văn Bảy\",\"unit\":\"Phòng Công nghệ thông tin\",\"eLearningCode\":\"EEEE\",\"password\":\"12345\",\"numLessons\":\"12\",\"status\":\"Không hủy\",\"email\":\"BAYCA@gmail.com\",\"position\":\"potision\",\"phoneNumber\":\"19001560\",\"note\":\"ok\"},{\"registerPersonel\":\"T211A\",\"fullName\":\"Huỳnh Văn Bánh\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"A03\",\"password\":\"ABC123\",\"numLessons\":\"12\",\"status\":\"Vắng\",\"email\":\"test@gmail.com\",\"position\":\"test\",\"phoneNumber\":\"8811111\",\"note\":null},{\"registerPersonel\":\"111111\",\"fullName\":\"Nguyễn Văn E1111\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"62AC\",\"password\":\"TEST\",\"numLessons\":\"11\",\"status\":\"Không hủy\",\"email\":\"test@gmail.com\",\"position\":\"gIAM1 NÓI\",\"phoneNumber\":\"111\",\"note\":null}]",
            "eTrainingType": "ĐỊNH KỲ",
            "eIssueNumber": "V.TMM-F23",
            "eIssueTimes": "04",
            "eIssueEffectiveDate": "2022-11-30T17:00:00Z",
            "eMajor": "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG",
            "eCourse": "Khái quát chung về hàng không dân dụng",
            "eCourseDate": "2023-10-30T04:01:36Z",
            "eCourseDateEnd": "2023-11-30T04:01:36Z",
            "eApprovedBy": "canbo1@viags.vn",
            "eApprovedDate": "2023-11-13T04:03:24Z",
            "eApprovedStatus": "Approved",
            "eApprovedByITLead": "canbo2@viags.vn",
            "eApprovedByITLeadStatus": "Approved",
            "eApprovedByITLeadDate": "2023-11-13T04:03:37Z",
            "eRequestStatus": "Completed",
            "eDepartment": "Chi nhánh Tân Sơn Nhất",
            "eSubRequestsStatus": "{\"Phòng Công nghệ thông tin\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Huỳnh Thông\"},\"Phòng Kinh doanh\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Lê Thị Ninh\"}}"
        },
        "eContent": "[{\"registerPersonel\":\"TuTEST\",\"fullName\":\"nGUYỄN Văn Bảy\",\"unit\":\"Phòng Công nghệ thông tin\",\"eLearningCode\":\"EEEE\",\"password\":\"12345\",\"numLessons\":\"12\",\"status\":\"Không hủy\",\"email\":\"BAYCA@gmail.com\",\"position\":\"potision\",\"phoneNumber\":\"19001560\",\"note\":\"ok\"},{\"registerPersonel\":\"T211A\",\"fullName\":\"Huỳnh Văn Bánh\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"A03\",\"password\":\"ABC123\",\"numLessons\":\"12\",\"status\":\"Vắng\",\"email\":\"test@gmail.com\",\"position\":\"test\",\"phoneNumber\":\"8811111\",\"note\":null},{\"registerPersonel\":\"111111\",\"fullName\":\"Nguyễn Văn E1111\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"62AC\",\"password\":\"TEST\",\"numLessons\":\"11\",\"status\":\"Không hủy\",\"email\":\"test@gmail.com\",\"position\":\"gIAM1 NÓI\",\"phoneNumber\":\"111\",\"note\":null}]",
        "Title": "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",
        "eTrainingType": "ĐỊNH KỲ",
        "eIssueNumber": "V.TMM-F23",
        "eIssueTimes": "04",
        "eIssueEffectiveDate": "2022-11-30T17:00:00Z",
        "eMajor": "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG",
        "eCourse": "Khái quát chung về hàng không dân dụng",
        "eCourseDate": "2023-10-30T04:01:36Z",
        "eCourseDateEnd": "2023-11-30T04:01:36Z",
        "eApprovedBy": "canbo1@viags.vn",
        "eApprovedDate": "2023-11-13T04:03:24Z",
        "eApprovedStatus": "Approved",
        "eApprovedByITLead": "canbo2@viags.vn",
        "eApprovedByITLeadStatus": "Approved",
        "eApprovedByITLeadDate": "2023-11-13T04:03:37Z",
        "eRequestStatus": "Completed",
        "eDepartment": "Chi nhánh Tân Sơn Nhất",
        "eSubRequestsStatus": "{\"Phòng Công nghệ thông tin\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Huỳnh Thông\"},\"Phòng Kinh doanh\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Lê Thị Ninh\"}}",
        "registerPersonel": "TuTEST",
        "fullName": "nGUYỄN Văn Bảy",
        "unit": "Phòng Công nghệ thông tin",
        "eLearningCode": "EEEE",
        "password": "12345",
        "numLessons": "12",
        "status": "Không hủy",
        "email": "BAYCA@gmail.com",
        "position": "potision",
        "phoneNumber": "19001560",
        "note": "ok"
    },
    {
        "@odata.etag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
        "createdDateTime": "2023-11-13T04:01:40Z",
        "eTag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
        "id": "105",
        "lastModifiedDateTime": "2023-11-13T04:23:54Z",
        "webUrl": "https://viagsvn.sharepoint.com/sites/eOfficeDev/Lists/eSummaryEmployeeRequests/105_.000",
        "createdBy": {
            "user": {
                "email": "canbo2@viags.vn",
                "id": "dc50f7c6-8163-42d5-a71d-d7ca62f532e5",
                "displayName": "Can bo 2-VIAGS"
            }
        },
        "lastModifiedBy": {
            "application": {
                "id": "3b7cd5f9-61dc-403b-a425-4d4b43518626",
                "displayName": "viagsoffice.com"
            },
            "user": {
                "email": "canbo1@viags.vn",
                "id": "e49bcd7f-5a27-4c8f-b8af-a70c9406830f",
                "displayName": "Can bo 1-VIAGS"
            }
        },
        "parentReference": {
            "id": "e078a4db-a88c-4c57-8ea4-4b9dfe2df068",
            "siteId": "viagsvn.sharepoint.com,e56d6e5f-9c23-48fb-b7f1-a0336add9496,c7953a0f-e5e6-43fd-8d18-d148e4f6eaf8"
        },
        "contentType": {
            "id": "0x0100B5B91118C9B0944F967418F192282F13",
            "name": "Khoản mục"
        },
        "fields@odata.context": "https://graph.microsoft.com/v1.0/$metadata#sites('e56d6e5f-9c23-48fb-b7f1-a0336add9496')/lists('16e2d37e-d1af-4426-ac9d-2e44b7394bcb')/items('105')/fields/$entity",
        "fields": {
            "@odata.etag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
            "Title": "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",
            "eContent": "[{\"registerPersonel\":\"TuTEST\",\"fullName\":\"nGUYỄN Văn Bảy\",\"unit\":\"Phòng Công nghệ thông tin\",\"eLearningCode\":\"EEEE\",\"password\":\"12345\",\"numLessons\":\"12\",\"status\":\"Không hủy\",\"email\":\"BAYCA@gmail.com\",\"position\":\"potision\",\"phoneNumber\":\"19001560\",\"note\":\"ok\"},{\"registerPersonel\":\"T211A\",\"fullName\":\"Huỳnh Văn Bánh\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"A03\",\"password\":\"ABC123\",\"numLessons\":\"12\",\"status\":\"Vắng\",\"email\":\"test@gmail.com\",\"position\":\"test\",\"phoneNumber\":\"8811111\",\"note\":null},{\"registerPersonel\":\"111111\",\"fullName\":\"Nguyễn Văn E1111\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"62AC\",\"password\":\"TEST\",\"numLessons\":\"11\",\"status\":\"Không hủy\",\"email\":\"test@gmail.com\",\"position\":\"gIAM1 NÓI\",\"phoneNumber\":\"111\",\"note\":null}]",
            "eTrainingType": "ĐỊNH KỲ",
            "eIssueNumber": "V.TMM-F23",
            "eIssueTimes": "04",
            "eIssueEffectiveDate": "2022-11-30T17:00:00Z",
            "eMajor": "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG",
            "eCourse": "Khái quát chung về hàng không dân dụng",
            "eCourseDate": "2023-10-30T04:01:36Z",
            "eCourseDateEnd": "2023-11-30T04:01:36Z",
            "eApprovedBy": "canbo1@viags.vn",
            "eApprovedDate": "2023-11-13T04:03:24Z",
            "eApprovedStatus": "Approved",
            "eApprovedByITLead": "canbo2@viags.vn",
            "eApprovedByITLeadStatus": "Approved",
            "eApprovedByITLeadDate": "2023-11-13T04:03:37Z",
            "eRequestStatus": "Completed",
            "eDepartment": "Chi nhánh Tân Sơn Nhất",
            "eSubRequestsStatus": "{\"Phòng Công nghệ thông tin\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Huỳnh Thông\"},\"Phòng Kinh doanh\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Lê Thị Ninh\"}}"
        },
        "eContent": "[{\"registerPersonel\":\"TuTEST\",\"fullName\":\"nGUYỄN Văn Bảy\",\"unit\":\"Phòng Công nghệ thông tin\",\"eLearningCode\":\"EEEE\",\"password\":\"12345\",\"numLessons\":\"12\",\"status\":\"Không hủy\",\"email\":\"BAYCA@gmail.com\",\"position\":\"potision\",\"phoneNumber\":\"19001560\",\"note\":\"ok\"},{\"registerPersonel\":\"T211A\",\"fullName\":\"Huỳnh Văn Bánh\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"A03\",\"password\":\"ABC123\",\"numLessons\":\"12\",\"status\":\"Vắng\",\"email\":\"test@gmail.com\",\"position\":\"test\",\"phoneNumber\":\"8811111\",\"note\":null},{\"registerPersonel\":\"111111\",\"fullName\":\"Nguyễn Văn E1111\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"62AC\",\"password\":\"TEST\",\"numLessons\":\"11\",\"status\":\"Không hủy\",\"email\":\"test@gmail.com\",\"position\":\"gIAM1 NÓI\",\"phoneNumber\":\"111\",\"note\":null}]",
        "Title": "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",
        "eTrainingType": "ĐỊNH KỲ",
        "eIssueNumber": "V.TMM-F23",
        "eIssueTimes": "04",
        "eIssueEffectiveDate": "2022-11-30T17:00:00Z",
        "eMajor": "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG",
        "eCourse": "Khái quát chung về hàng không dân dụng",
        "eCourseDate": "2023-10-30T04:01:36Z",
        "eCourseDateEnd": "2023-11-30T04:01:36Z",
        "eApprovedBy": "canbo1@viags.vn",
        "eApprovedDate": "2023-11-13T04:03:24Z",
        "eApprovedStatus": "Approved",
        "eApprovedByITLead": "canbo2@viags.vn",
        "eApprovedByITLeadStatus": "Approved",
        "eApprovedByITLeadDate": "2023-11-13T04:03:37Z",
        "eRequestStatus": "Completed",
        "eDepartment": "Chi nhánh Tân Sơn Nhất",
        "eSubRequestsStatus": "{\"Phòng Công nghệ thông tin\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Huỳnh Thông\"},\"Phòng Kinh doanh\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Lê Thị Ninh\"}}",
        "registerPersonel": "T211A",
        "fullName": "Huỳnh Văn Bánh",
        "unit": "Phòng Kinh doanh",
        "eLearningCode": "A03",
        "password": "ABC123",
        "numLessons": "12",
        "status": "Vắng",
        "email": "test@gmail.com",
        "position": "test",
        "phoneNumber": "8811111",
        "note": null
    },
    {
        "@odata.etag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
        "createdDateTime": "2023-11-13T04:01:40Z",
        "eTag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
        "id": "105",
        "lastModifiedDateTime": "2023-11-13T04:23:54Z",
        "webUrl": "https://viagsvn.sharepoint.com/sites/eOfficeDev/Lists/eSummaryEmployeeRequests/105_.000",
        "createdBy": {
            "user": {
                "email": "canbo2@viags.vn",
                "id": "dc50f7c6-8163-42d5-a71d-d7ca62f532e5",
                "displayName": "Can bo 2-VIAGS"
            }
        },
        "lastModifiedBy": {
            "application": {
                "id": "3b7cd5f9-61dc-403b-a425-4d4b43518626",
                "displayName": "viagsoffice.com"
            },
            "user": {
                "email": "canbo1@viags.vn",
                "id": "e49bcd7f-5a27-4c8f-b8af-a70c9406830f",
                "displayName": "Can bo 1-VIAGS"
            }
        },
        "parentReference": {
            "id": "e078a4db-a88c-4c57-8ea4-4b9dfe2df068",
            "siteId": "viagsvn.sharepoint.com,e56d6e5f-9c23-48fb-b7f1-a0336add9496,c7953a0f-e5e6-43fd-8d18-d148e4f6eaf8"
        },
        "contentType": {
            "id": "0x0100B5B91118C9B0944F967418F192282F13",
            "name": "Khoản mục"
        },
        "fields@odata.context": "https://graph.microsoft.com/v1.0/$metadata#sites('e56d6e5f-9c23-48fb-b7f1-a0336add9496')/lists('16e2d37e-d1af-4426-ac9d-2e44b7394bcb')/items('105')/fields/$entity",
        "fields": {
            "@odata.etag": "\"0b4dcd34-99bb-4bbe-884b-860dde548eda,7\"",
            "Title": "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",
            "eContent": "[{\"registerPersonel\":\"TuTEST\",\"fullName\":\"nGUYỄN Văn Bảy\",\"unit\":\"Phòng Công nghệ thông tin\",\"eLearningCode\":\"EEEE\",\"password\":\"12345\",\"numLessons\":\"12\",\"status\":\"Không hủy\",\"email\":\"BAYCA@gmail.com\",\"position\":\"potision\",\"phoneNumber\":\"19001560\",\"note\":\"ok\"},{\"registerPersonel\":\"T211A\",\"fullName\":\"Huỳnh Văn Bánh\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"A03\",\"password\":\"ABC123\",\"numLessons\":\"12\",\"status\":\"Vắng\",\"email\":\"test@gmail.com\",\"position\":\"test\",\"phoneNumber\":\"8811111\",\"note\":null},{\"registerPersonel\":\"111111\",\"fullName\":\"Nguyễn Văn E1111\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"62AC\",\"password\":\"TEST\",\"numLessons\":\"11\",\"status\":\"Không hủy\",\"email\":\"test@gmail.com\",\"position\":\"gIAM1 NÓI\",\"phoneNumber\":\"111\",\"note\":null}]",
            "eTrainingType": "ĐỊNH KỲ",
            "eIssueNumber": "V.TMM-F23",
            "eIssueTimes": "04",
            "eIssueEffectiveDate": "2022-11-30T17:00:00Z",
            "eMajor": "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG",
            "eCourse": "Khái quát chung về hàng không dân dụng",
            "eCourseDate": "2023-10-30T04:01:36Z",
            "eCourseDateEnd": "2023-11-30T04:01:36Z",
            "eApprovedBy": "canbo1@viags.vn",
            "eApprovedDate": "2023-11-13T04:03:24Z",
            "eApprovedStatus": "Approved",
            "eApprovedByITLead": "canbo2@viags.vn",
            "eApprovedByITLeadStatus": "Approved",
            "eApprovedByITLeadDate": "2023-11-13T04:03:37Z",
            "eRequestStatus": "Completed",
            "eDepartment": "Chi nhánh Tân Sơn Nhất",
            "eSubRequestsStatus": "{\"Phòng Công nghệ thông tin\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Huỳnh Thông\"},\"Phòng Kinh doanh\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Lê Thị Ninh\"}}"
        },
        "eContent": "[{\"registerPersonel\":\"TuTEST\",\"fullName\":\"nGUYỄN Văn Bảy\",\"unit\":\"Phòng Công nghệ thông tin\",\"eLearningCode\":\"EEEE\",\"password\":\"12345\",\"numLessons\":\"12\",\"status\":\"Không hủy\",\"email\":\"BAYCA@gmail.com\",\"position\":\"potision\",\"phoneNumber\":\"19001560\",\"note\":\"ok\"},{\"registerPersonel\":\"T211A\",\"fullName\":\"Huỳnh Văn Bánh\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"A03\",\"password\":\"ABC123\",\"numLessons\":\"12\",\"status\":\"Vắng\",\"email\":\"test@gmail.com\",\"position\":\"test\",\"phoneNumber\":\"8811111\",\"note\":null},{\"registerPersonel\":\"111111\",\"fullName\":\"Nguyễn Văn E1111\",\"unit\":\"Phòng Kinh doanh\",\"eLearningCode\":\"62AC\",\"password\":\"TEST\",\"numLessons\":\"11\",\"status\":\"Không hủy\",\"email\":\"test@gmail.com\",\"position\":\"gIAM1 NÓI\",\"phoneNumber\":\"111\",\"note\":null}]",
        "Title": "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",
        "eTrainingType": "ĐỊNH KỲ",
        "eIssueNumber": "V.TMM-F23",
        "eIssueTimes": "04",
        "eIssueEffectiveDate": "2022-11-30T17:00:00Z",
        "eMajor": "KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG",
        "eCourse": "Khái quát chung về hàng không dân dụng",
        "eCourseDate": "2023-10-30T04:01:36Z",
        "eCourseDateEnd": "2023-11-30T04:01:36Z",
        "eApprovedBy": "canbo1@viags.vn",
        "eApprovedDate": "2023-11-13T04:03:24Z",
        "eApprovedStatus": "Approved",
        "eApprovedByITLead": "canbo2@viags.vn",
        "eApprovedByITLeadStatus": "Approved",
        "eApprovedByITLeadDate": "2023-11-13T04:03:37Z",
        "eRequestStatus": "Completed",
        "eDepartment": "Chi nhánh Tân Sơn Nhất",
        "eSubRequestsStatus": "{\"Phòng Công nghệ thông tin\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Huỳnh Thông\"},\"Phòng Kinh doanh\":{\"status\":\"Completed\",\"approver\":\"canbo1@viags.vn|Lê Thị Ninh\"}}",
        "registerPersonel": "111111",
        "fullName": "Nguyễn Văn E1111",
        "unit": "Phòng Kinh doanh",
        "eLearningCode": "62AC",
        "password": "TEST",
        "numLessons": "11",
        "status": "Không hủy",
        "email": "test@gmail.com",
        "position": "gIAM1 NÓI",
        "phoneNumber": "111",
        "note": null
    }
]

*/
